const CAMERA_PREF_KEY = 'dartleague_online_camera_pref';

export const getCameraPreference = () => {
  try {
    const raw = localStorage.getItem(CAMERA_PREF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.deviceId) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveCameraPreference = ({ deviceId, label = '' }) => {
  if (!deviceId) return;
  const payload = {
    deviceId,
    label,
    savedAt: Date.now(),
  };
  localStorage.setItem(CAMERA_PREF_KEY, JSON.stringify(payload));
};

export const clearCameraPreference = () => {
  localStorage.removeItem(CAMERA_PREF_KEY);
};

export const listVideoInputDevices = async () => {
  if (!navigator?.mediaDevices?.enumerateDevices) return [];
  const devices = await navigator.mediaDevices.enumerateDevices();
  return devices
    .filter((d) => d.kind === 'videoinput')
    .map((d, i) => ({
      deviceId: d.deviceId,
      label: d.label || `Cámara ${i + 1}`,
    }));
};

export const probeCameraDevice = async (deviceId) => {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: deviceId ? { deviceId: { exact: deviceId } } : true,
    audio: false,
  });

  const videoTrack = stream.getVideoTracks()[0];
  const settings = videoTrack?.getSettings?.() || {};
  const finalDeviceId = settings.deviceId || deviceId || null;
  const finalLabel = videoTrack?.label || '';

  stream.getTracks().forEach((track) => track.stop());

  return {
    deviceId: finalDeviceId,
    label: finalLabel,
  };
};

export const precheckPreferredCamera = async () => {
  if (!navigator?.mediaDevices?.getUserMedia) {
    return {
      ok: false,
      reason: 'not_supported',
      message: 'Tu navegador no soporta acceso a cámara.',
    };
  }

  const preferred = getCameraPreference();
  if (!preferred?.deviceId) {
    return {
      ok: false,
      reason: 'not_configured',
      message: 'Configura tu cámara antes de invitar o aceptar retos online.',
    };
  }

  try {
    await probeCameraDevice(preferred.deviceId);
    return { ok: true, deviceId: preferred.deviceId };
  } catch (err) {
    if (err?.name === 'NotAllowedError') {
      return {
        ok: false,
        reason: 'permission_denied',
        message: 'Permiso de cámara denegado. Debes permitir el acceso para jugar online.',
      };
    }

    if (err?.name === 'NotFoundError' || err?.name === 'OverconstrainedError') {
      return {
        ok: false,
        reason: 'device_missing',
        message: 'La cámara configurada ya no está disponible. Selecciona otra para continuar.',
      };
    }

    return {
      ok: false,
      reason: 'camera_error',
      message: 'No se pudo validar la cámara configurada. Vuelve a configurarla.',
    };
  }
};
